import router from "@/router"
import { isPromiseLike } from "@/util/object"

const gotoDefaults = {}

// noinspection JSValidateTypes
/**
 * Provides flexible router navigation. Combination of go, push, and replace on
 * router.
 *
 * Options:
 *  - defaultTo {String|Function|Number|Object} the default destination (default: null)
 *  - replace {Boolean} whether or not to call router push or replace
 *      (default: true if the current route is marked as transient, otherwise false)
 *
 * @param to {String|Function|Number|Object} the destination route
 * @param options goto options
 * @return {Promise<*>}
 */
export const goto = function(to, options = gotoDefaults) {
    if (to == null && options.defaultTo) to = options.defaultTo
    if (to == null) return Promise.resolve()
    if (typeof to === "function") to = to()
    if (to == null) return Promise.resolve()
    if (isPromiseLike(to)) return Promise.resolve(to)

    if (typeof to === "number") {
        router.go(to)
        return Promise.resolve()
    }

    let location = to

    if (typeof location === "string") {
        location = {}

        if (to[0] === "/") {
            location.path = to
        } else {
            location.name = to
        }
    }

    let replace = options.replace

    if (replace == null) {
        replace = !!router.currentRoute?.meta?.transient
    }

    if (replace) {
        return router.replace(location)
    } else {
        return router.push(location)
    }
}
